import {GetHistoryWithFilterRequest, HistoryModel} from "./models";
import {HttpClientError, RequestStatus} from "../../../http-client";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {RootState} from "../../../app/store";
import PoleHistoryApi from "./poleHistory.api";


export interface PoleHistorySlice {
    historyList?: Array<HistoryModel>;
    historyRows?: number;
    isLoading?: boolean;
    status?: RequestStatus;
    error?: HttpClientError;
}

export const getPoleHistory = createAsyncThunk(
    'history/getPoleHistory',
    async (args: GetHistoryWithFilterRequest, { getState, rejectWithValue }) => {
        try {
            const { userAuth } = (getState() as RootState).user;
            return await PoleHistoryApi.getPoleHistory(args, userAuth?.id as string);
        } catch (e) {
            return rejectWithValue(e as HttpClientError);
        }
    });

const poleHistorySlice = createSlice({
    name: 'historyState',
    initialState: {} as PoleHistorySlice,
    reducers: {},
    extraReducers: builder => {
        // get history
        builder.addCase(getPoleHistory.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getPoleHistory.fulfilled, (state, action) => {
            state.isLoading = false;
            state.historyList = action.payload.data;
            state.historyRows = action.payload.rows;
        });
        builder.addCase(getPoleHistory.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload as HttpClientError;
        });
    }
});

export default poleHistorySlice.reducer;